import React, { useState, /*useRef,*/ useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';

import { selectUid/*, selectToken*/ } from '../login/LoginSlice';
import { getLogsDataAsync, selectLogsData } from './LogSlice';
//import { selectPrjId, selectPrjName } from '../summary/SummarySlice';
import { selectPrj } from '../summary/SummarySlice';


const LogsIcon = ({status}) => {
    switch (status) {
        case 'info':
        case 'INFO':
            return (<i className="material-icons icon-green">check_circle</i>);
        case 'error':
        case 'ERROR':
            return (<i className="material-icons icon-red">error</i>);
        case 'warn':
        case 'WARN':
            return (<i className="material-icons icon-yellow">warning</i>);
        default:
            return (<i className="material-icons icon-gray">help</i>);
    }
};

const BatchLogRows = ({batchLogs, ...props}) => {
    const rows = batchLogs.map((batchLog, index) => {
        
        return (
          <TableRow>
            <TableCell>
                <LogsIcon status={batchLog.status}/>
            </TableCell>
            <TableCell>{batchLog.logTime}</TableCell>
            <TableCell>{batchLog.batchName}</TableCell>
            <TableCell>{batchLog.jobName}</TableCell>
            <TableCell>{batchLog.eventName}</TableCell>
            <TableCell>{batchLog.message}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const BatchLogTable = ({batchLogs, ...props}) => {
    if (batchLogs.length === 0)
        return (<div></div>);

        return (
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell colSpan={5}>
              <Typography>Batch Log</Typography>
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell>Status</TableCell>
            <TableCell>Log Time</TableCell>
            <TableCell>Batch Name</TableCell>
            <TableCell>Job Name</TableCell>
            <TableCell>Event Name</TableCell>
            <TableCell>Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <BatchLogRows batchLogs={batchLogs}/>
        </TableBody>
      </Table>
    );
}

const MaintLogRows = ({maintLogs, ...props}) => {
    const rows = maintLogs.map((maintLog, index) => {
      
        return (
          <TableRow>
            <TableCell>
                <LogsIcon status={maintLog.status}/>
            </TableCell>
            <TableCell>{maintLog.logTime}</TableCell>
            <TableCell>{maintLog.maintName}</TableCell>
            <TableCell>{maintLog.targetName}</TableCell>
            <TableCell>{maintLog.serverName}</TableCell>
            <TableCell>{maintLog.message}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const MaintLogTable = ({maintLogs,...props}) => {
    if (maintLogs.length === 0)
        return (<div></div>);

        return (
        <Table size="small">
          <TableHead>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell colSpan={5}>
                <Typography>Batch</Typography>
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell>Status</TableCell>
              <TableCell>Log Time</TableCell>
              <TableCell>Maint Name</TableCell>
              <TableCell>Target Name</TableCell>
              <TableCell>Server Name</TableCell>
              <TableCell>Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <MaintLogRows maintLogs={maintLogs}/>
          </TableBody>
        </Table>
    );
};


const CheckLogRows = ({checkLogs, ...props}) => {
  const rows = checkLogs.map((checkLog, index) => {
      
      return (
        <TableRow>
            <TableCell>
                <LogsIcon status={checkLog.status}/>
            </TableCell>
            <TableCell>{checkLog.logTime}</TableCell>
            <TableCell>{checkLog.checkName}</TableCell>
            <TableCell>{checkLog.targetName}</TableCell>
            <TableCell>{checkLog.serverName}</TableCell>
            <TableCell>{checkLog.message}</TableCell>
        </TableRow>
      );
});
return rows;    
};

const CheckLogTable = ({checkLogs, ...props}) => {
  
  if (checkLogs.length === 0)
      return (<div></div>);
  
  return (
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell colSpan={5}>
              <Typography>Check log</Typography>
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: "#F0F0F0" }}>
            <TableCell>Status</TableCell>
            <TableCell>Log Time</TableCell>
            <TableCell>Check Name</TableCell>
            <TableCell>Target Name</TableCell>
            <TableCell>Server Name</TableCell>
            <TableCell>Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <CheckLogRows checkLogs={checkLogs} />
        </TableBody>
      </Table>
    );
}

const PgLogRows = ({pgLogs, ...props}) => {
    const rows = pgLogs.map((pgLog, index) => {
        
        return (
          <TableRow>
            <TableCell>
                <LogsIcon status={pgLog.status}/>
            </TableCell>
            <TableCell>{pgLog.logTime}</TableCell>
            <TableCell>{pgLog.message}</TableCell>
          </TableRow>
        );
  });
  return rows;    
};

const PgLogTable = ({pgLogs, ...props}) => {
    
    if (pgLogs.length === 0)
        return (<div></div>);
    
    return (
        <Table size="small">
          <TableHead>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell colSpan={5}>
                <Typography>Maintenance</Typography>
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: "#F0F0F0" }}>
              <TableCell>Status</TableCell>
              <TableCell>Event Name</TableCell>
              <TableCell>Batch Name</TableCell>
              <TableCell>Job Name</TableCell>
              <TableCell>Ckeck Time</TableCell>
              <TableCell>Start</TableCell>
              <TableCell>End</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <PgLogRows pgLogs={pgLogs} />
          </TableBody>
        </Table>
      );
}

const LogList = ({ ...props }) => {
    const dispatch = useDispatch();

    const uid = useSelector(selectUid);
    //const token = useSelector(selectToken);
    //const prjId = useSelector(selectPrjId);
    //const prjName = useSelector(selectPrjName);
    const prj = useSelector(selectPrj);
    const logsData = useSelector(selectLogsData);

    const [fromDt, setFromDt] = useState(new Date());
    const [toDt, setToDt] = useState(new Date());


    const loadItems = () => {
        dispatch(getLogsDataAsync({ 
            /*token: token,*/ uid: uid, prjId:prj.prjId, fromDt: fromDt.toISOString(), toDt: toDt.toISOString() }));
    };

    useEffect(() => {
        loadItems();

        const interval = setInterval(() => {
            loadItems();
        }, 60000);
        return () => clearInterval(interval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div>
            <DatePicker renderInput={(params) => <TextField {...params} />} />
            <TableContainer>
                <BatchLogTable batchLogs={logsData.batchLogs}/>
                <MaintLogTable maintLogs={logsData.maintLogs}/>
                <CheckLogTable checkLogs={logsData.checkLogs}/>
                <PgLogTable  pgLogs={logsData.pgLogs}/>
            </TableContainer>    
        </div>
    );
};

export default LogList;
